<script setup lang="ts">
</script>

<template>
    <div class="mb-2">
        <label class="font-weight-bold text-body-2 field-label">
            <slot />
        </label>
        <slot name="append" />
    </div>
</template>

<style scoped>
.field-label {
    font-size: 0.825rem !important;
}
</style>
